import { render, staticRenderFns } from "./AxScopelessbar.vue?vue&type=template&id=fd1a6f62&"
import script from "./AxScopelessbar.vue?vue&type=script&lang=ts&"
export * from "./AxScopelessbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd1a6f62')) {
      api.createRecord('fd1a6f62', component.options)
    } else {
      api.reload('fd1a6f62', component.options)
    }
    module.hot.accept("./AxScopelessbar.vue?vue&type=template&id=fd1a6f62&", function () {
      api.rerender('fd1a6f62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/scopelessbar/AxScopelessbar.vue"
export default component.exports